import { MstrCategoriesResponse } from "types/view";
import { emptySplitApi } from "./emptySplitApi";
import { DISPLAY_MSTR_CATEGORIES_URL } from "constants/apiEndpoints";

// Define service slice and endpoints.
const displayDataApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getMstrCategoriesResponseData: builder.query<MstrCategoriesResponse, void>({
      query: () => ({
        url: DISPLAY_MSTR_CATEGORIES_URL,
        method: "GET",
      }),
      providesTags: ["MstrCategories"],
    }),
  }),
  overrideExisting: false,
});

// Define hooks.
const { useGetMstrCategoriesResponseDataQuery, useLazyGetMstrCategoriesResponseDataQuery } = displayDataApi;

// Export slice and hooks.
export { displayDataApi, useGetMstrCategoriesResponseDataQuery, useLazyGetMstrCategoriesResponseDataQuery };
